import React from 'react'
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import {yearMonthDay} from '../../utils/dates'

export default ({isEndDate, title, placeholder, onChange, getRef, defaultValue}) => {

  let currentDate = yearMonthDay(defaultValue ? defaultValue : new Date())

  return (
      <FormGroup controlId={isEndDate ? 'endDate' : 'beginDate'}>
        <ControlLabel>
          {title}
        </ControlLabel>
        <FormControl
            type="date"
            defaultValue={yearMonthDay(currentDate)}
            placeholder={placeholder}
            onChange={date => {
              console.log('date.target.value', date.target.value);
              const fields = date.target.value.split('-');
              let newDate;
              if (isEndDate) {
                newDate = new Date(fields[0], fields[1] - 1, fields[2], 23, 59, 59);
              } else {
                newDate = new Date(fields[0], fields[1] - 1, fields[2], 0, 0, 0);
              }
              if (this.timeout) {
                clearTimeout(this.timeout);
              }
              this.timeout = setTimeout(() => {
                onChange && onChange(newDate);
              }, 500);
            }}
            inputRef={ref => getRef ? getRef(ref) : null}
        />
        <FormControl.Feedback/>
      </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/component/Date/DateSelector.js